var _path, _path2, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBg2K(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 2539,
    height: 160,
    viewBox: "0 0 2539 160",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2539 0H0V60C0 115.228 44.7715 160 100 160H2539V0Z",
    fill: "#5964E0"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_0_2936",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 2539,
    height: 160
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2539 0H0V60C0 115.228 44.7715 160 100 160H2539V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_0_2936)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.0813802,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2096.1 -233.69C2118.25 -247.939 2145.49 -244.655 2155.5 -226.528L2373.58 168.158C2388.75 195.618 2355.28 233.516 2319.65 229.221L1619.3 144.792C1583.67 140.497 1580.27 98.1536 1613.82 76.5683L2096.1 -233.69Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.0813802,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M443.954 -351.298C440.289 -372.496 473.317 -385.612 507.185 -376.409L1180.78 -193.366C1218.97 -182.988 1229.31 -152.715 1198.81 -140.6L598.109 97.9518C567.601 110.067 520.982 94.2008 516.848 70.2957L443.954 -351.298Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.0813802,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M-130.847 43.7016C-134.512 22.504 -101.484 9.3878 -67.6161 18.5911L605.975 201.634C644.169 212.012 654.513 242.285 624.005 254.4L23.3076 492.952C-7.20013 505.067 -53.8197 489.201 -57.9529 465.296L-130.847 43.7016Z",
    fill: "white"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBg2K);
export default __webpack_public_path__ + "static/media/bg2K.f00a35f99e57d803e93ec4f5465c98c9.svg";
export { ForwardRef as ReactComponent };